module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan3-2-a34d35a973a1bf8ea06de4ab6b7fda54.webp";